import React, { useState, useEffect } from "react";
import {
  BaseUrl,
  excelDownloadUrl,
  newBaseUrlLang,
  systemTimeZone,
} from "../../container/BaseUrl/BaseUrl";
import FileSaver from "file-saver";
import axios from "axios";
import { toast } from "react-toastify";
import {
  Button,
  IconButton,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography,
  FormControl,
  styled,
} from "@mui/material";
import facebook from "../../assets/assets/images/facebook.png";
import whatsapp from "../../assets/assets/images/whatsapp.png";
import webchat from "../../assets/assets/images/chat-icon.png";
import twitter from "../../assets/assets/images/twitter.png";
import email from "../../assets/assets/images/email.png";
import voice from "../../assets/assets/images/voice.png";
import chatbot from "../../assets/assets/images/chatbot.png";
import videochat from "../../assets/assets/images/videochat.png";
import teams from "../../assets/assets/images/teams.png";

import {
  DownloadSimple,
  Eye,
  FunnelSimple,
  GitPullRequest,
  PhoneOutgoing,
  PhoneIncoming,
  PhoneX,
} from "@phosphor-icons/react";
import moment from "moment";
import moment2 from "moment-timezone";
import { Badge } from "react-bootstrap";
import { RiErrorWarningLine } from "react-icons/ri";
import {
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Slide,
} from "@mui/material";
import ViewMoreDialogBox from "./ViewMoreDialogBox";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export const FormControls = styled(FormControl)(({ theme }) => ({
  minWidth: "70px",
  width: "3%",
  backgroundColor: "#fff",
  borderRadius: "5px",
  border: "1px solid #fff",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fff",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
      boxShadow: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
export const Selects = styled(Select)(() => ({
  fontSize: "12px",
  "& .MuiSelect-select": {
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingRight: "12px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
}));
export const MenuItems = styled(MenuItem)(() => ({
  fontSize: "12px",
}));

const Sessionreport = () => {
  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  const [showfilter, setshowfilter] = useState("sidebar_filter");
  const tenantId = localStorage.getItem("TenantId");

  const [skilldropdown, setSkilldropdown] = useState([]);
  const [languagedropdown, setLanguagedropdown] = useState([]);

  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [status, setStatus] = useState("");
  const [agentid, setAgentid] = useState("");
  const [sessionreport, setSessionreport] = useState([]);
  const [agentlist, setAgentlist] = useState([]);
  const [multiPageVal, setMultiPageVal] = React.useState(10);
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loadingreports, setloadingreports] = useState(false);
  const [userdetails, setuserdetails] = useState();
  const [openDialogbox, setopenDialogbox] = useState(false);
  const [direction, setdirection] = useState("");
  const [skillset, setSkillset] = useState("");

  const [ChatHistoryOpenDialog, setChatHistoryOpenDialog] = useState(false);
  const [ChatHistory, setChatHistory] = useState([]);

  const ChatHistoryCloseDialog = () => {
    setChatHistoryOpenDialog(false);
  };

  useEffect(() => {
    if (basedOnRole.role == "Supervisor") {
      agentListdropdown();
    }
  }, []);

  useEffect(() => {
    sessionReports();
  }, [page, multiPageVal]);

  const sessionReports = async () => {
    await axios
      .post(
        BaseUrl + "/reports/listDetails",
        {
          agent_id: basedOnRole.role == "Supervisor" ? agentid : basedOnRole.id,
          agent_supervisor: basedOnRole.id,
          status: status,
          from_date: fromdate ? fromdate : "",
          to_date: todate ? todate : "",
          limit: multiPageVal,
          offset: page == 1 ? 0 : (page - 1) * multiPageVal,
          agent: basedOnRole.role == "Supervisor" ? agentid : "",
          direction: direction,
          skillset: skillset,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success == true) {
          setSessionreport(res.data.Data);
          setPagination(res.data.count);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSessionreport([]);
          setPagination(0);
        }
      })
      .catch((error) => {
        setShow(true);
      });
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleChangeSetPage = async (event) => {
    setMultiPageVal(event.target.value);
    setPage(1);
  };

  const agentListdropdown = async () => {
    await axios
      .post(
        BaseUrl + "/users/listagentList",
        {
          user_id: basedOnRole.user_id,
          type: "AllAgent",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setAgentlist(res.data.data);
      })
      .catch((err) => {
        setShow(true);
      });
  };

  const skillsetDropdown = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/skills/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        setSkilldropdown(res.data.dataList);
      })
      .catch((error) => {});
  };
  const languageDropdownList = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/languages/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setLanguagedropdown(res.data.dataList);
      })
      .catch((error) => {});
  };

  const DownloadSessionReports = () => {
    axios
      .post(
        BaseUrl + "/reports/listDetailsExcel",
        {
          agent_id: basedOnRole.role == "Supervisor" ? agentid : basedOnRole.id,
          agent_supervisor: basedOnRole.id,
          status: status,
          from_date: fromdate ? fromdate : "",
          to_date: todate ? todate : "",
          limit: multiPageVal,
          offset: page == 1 ? 0 : (page - 1) * multiPageVal,
          agent: basedOnRole.role == "Supervisor" ? agentid : "",
          direction: direction,
          skillset: skillset,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
        {}
      )
      .then((res) => {
        if (res.data.status == true) {
          let file = excelDownloadUrl + res.data.message;
          FileSaver.saveAs(file);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {});
  };

  const ViewMore = (id) => {
    axios
      .post(
        BaseUrl + "/reports/viewmore",
        {
          id: id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setuserdetails(res.data.Data[0]);
          setopenDialogbox(true);
        }
      })
      .catch((err) => {});
  };

  const ChatPull = (value) => {
    let agent = JSON.parse(localStorage.getItem("tokenAgent"));
    axios
      .post(
        BaseUrl + "/users/chatpull",
        {
          chat_session_id: value.chat_session_id,
          agent_id: agent.agent_id,
          user_id: agent.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {})
      .catch((err) => {});
  };

  let sortedItemsSkillset = skilldropdown.slice().sort();
  sortedItemsSkillset.sort((a, b) => a.skillName.localeCompare(b.skillName));
  const sortedItemsLanguage = languagedropdown.slice().sort();
  sortedItemsLanguage.sort((a, b) =>
    a.languageDesc.localeCompare(b.languageDesc)
  );

  const showChatHistoryDialogBox = async (value) => {
    await axios
      .post(
        BaseUrl + "/message/chatHistories/",
        { sessionId: value },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setChatHistory(res.data.data);
          setChatHistoryOpenDialog(true);
        } else {
          setChatHistory([]);
          setChatHistoryOpenDialog(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setChatHistory([]);
        setChatHistoryOpenDialog(false);
      });
  };

  useEffect(() => {
    languageDropdownList();
    skillsetDropdown();
  }, []);

  return (
    <div className="sessiontable" style={{ overflow: "hidden" }}>
      <header className="header_role ">
        <div className="conatiner-fluid">
          <nav
            className="navbar "
            style={{ paddingTop: "0px", paddingBottom: "0px" }}
          >
            <div className="container-fluid p-0">
              <div className="hed_left d-flex"></div>
              <div className="hed_right d-flex">
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <Button
                    size="small"
                    variant="contained"
                    endIcon={<DownloadSimple size={18} weight="bold" />}
                    onClick={DownloadSessionReports}
                  >
                    Download
                  </Button>

                  <Button
                    size="small"
                    variant="contained"
                    endIcon={<FunnelSimple size={18} weight="bold" />}
                    onClick={() => {
                      setshowfilter("sidebar_filter active-r");
                    }}
                  >
                    Filter
                  </Button>
                </Stack>
              </div>
            </div>
          </nav>
        </div>
      </header>

      <div className="multimediatable container-fluid">
        <div className="card fixed-table-card vh-79 multimediacard">
          <div className="card-body agentContactbody">
            <div className="table-responsive vhm-68">
              <table className="table table-sm table-hover align-middle table-fixeded">
                <thead>
                  <tr>
                    <th scope="col">Customer Name</th>
                    <th scope="col">Phone Number</th>
                    <th scope="col">Email</th>
                    <th scope="col">Channel</th>
                    <th scope="col">Direction</th>

                    <th scope="col">Skillset</th>
                    <th scope="col">Language</th>
                    <th scope="col">Agent Name</th>
                    <th scope="col">Initiated At</th>
                    <th scope="col">Started At</th>
                    <th scope="col">Ended At</th>
                    <th scope="col">Disposition code</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingreports ? (
                    [...Array(8)].map((_, rowIndex) => (
                      <tr key={rowIndex}>
                        {[...Array(13)].map((_, colIndex) => (
                          <td key={colIndex}>
                            <Skeleton variant="text" width={60} height={30} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : sessionreport.length > 0 ? (
                    sessionreport.map((rowData, rowIndex) => (
                      <tr key={rowIndex._id} className="text-break">
                        <td>{rowData.name}</td>
                        <td>{rowData.phone_number}</td>
                        <td>{rowData.email}</td>
                        <td>
                          {rowData.channel == "webchat" ? (
                            <img
                              className="icons-size"
                              src={webchat}
                              alt="webchat"
                            />
                          ) : rowData.channel == "from_whatsapp" ? (
                            <img
                              className="icons-size"
                              src={whatsapp}
                              alt="webchat"
                            />
                          ) : rowData.channel == "from_twitter" ? (
                            <img
                              className="icons-size"
                              src={twitter}
                              alt="webchat"
                            />
                          ) : rowData.channel == "voice" ? (
                            rowData.direction == "Inbound" ? (
                              <PhoneIncoming size={22} weight="bold" />
                            ) : rowData.direction == "Missed Call" ? (
                              <PhoneX size={22} weight="bold" />
                            ) : (
                              <PhoneOutgoing size={22} weight="bold" />
                            )
                          ) : rowData.channel == "from_facebook" ? (
                            (
                              <img
                                className="icons-size"
                                src={facebook}
                                alt="webchat"
                              />
                            ) || rowData.channel == "from_teams"
                          ) : (
                            <img
                              className="icons-size"
                              src={email}
                              alt="webchat"
                            />
                          )}
                        </td>
                        <td>{rowData.direction}</td>

                        <td>{rowData.skillset}</td>
                        <td>{rowData.language}</td>
                        <td>{rowData.agent_name ? rowData.agent_name : ""}</td>
                        <td>
                          {moment2(rowData.chat_arrival_at)
                            .tz(systemTimeZone)
                            .format("l LT")}
                        </td>
                        <td>
                          {moment2(rowData.chat_started_at)
                            .tz(systemTimeZone)
                            .format("l LT")}
                        </td>
                        <td>
                          {rowData.chat_ended_at == null ||
                          rowData.chat_ended_at == undefined ||
                          rowData.chat_ended_at == ""
                            ? "--"
                            : moment2(rowData.chat_ended_at)
                                .tz(systemTimeZone)
                                .format("l LT")}
                        </td>

                        <td>
                          {rowData.reason == null ||
                          rowData.reason == undefined ||
                          rowData.reason == ""
                            ? "--"
                            : rowData.reason}
                        </td>

                        <td>
                          {rowData.status == "chatEnded" ? (
                            <Badge variant="secondary">Completed</Badge>
                          ) : (
                            <Badge variant="success">Active </Badge>
                          )}
                        </td>
                        <td>
                          {rowData.channel !== "voice" &&
                          rowData.channel !== "email" ? (
                            <IconButton
                              onClick={() => {
                                showChatHistoryDialogBox(
                                  rowData.chat_session_id
                                );
                              }}
                            >
                              <Eye size={18} />
                            </IconButton>
                          ) : null}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr key="">
                      <td colSpan="15">
                        <div
                          className="text-muted"
                          style={{
                            flexDirection: "column",
                            marginTop: "20%",
                            display: "flex",
                            position: "absolute",
                            left: "45%",
                            bottom: "40%",
                          }}
                        >
                          <span className="mx-auto">
                            <RiErrorWarningLine size={30} />
                          </span>
                          <span className="mx-auto">
                            <h5
                              className="text-muted mt-2"
                              style={{ fontFamily: "poppins" }}
                            >
                              No Data Found
                            </h5>
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="card-footer rounded-0 d-flex justify-content-between">
            <div>
              {`Showing ${Math.min(
                (page - 1) * multiPageVal + 1,
                isNaN(pagination) ? 0 : pagination
              )} to ${Math.min(
                page * multiPageVal,
                isNaN(pagination) ? 0 : pagination
              )} From ${isNaN(pagination) ? 0 : pagination} entries`}
            </div>
            <div className="d-flex">
              <Typography
                className="mt-1"
                sx={{ textTransform: "capitalize", fontSize: "12px" }}
              >
                Set page
              </Typography>
              <FormControls
                className="ms-1"
                size="small"
                sx={{ textTransform: "capitalize", fontSize: "12px" }}
              >
                <Selects
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  label="multiPageVal"
                  value={multiPageVal}
                  onChange={handleChangeSetPage}
                >
                  <MenuItems value={10}>10</MenuItems>
                  <MenuItems value={20}>20</MenuItems>
                  <MenuItems value={50}>50</MenuItems>
                  <MenuItems value={100}>100</MenuItems>
                  <MenuItems value={500}>500</MenuItems>
                </Selects>
              </FormControls>
            </div>
            <Pagination
              count={Math.ceil(pagination / multiPageVal)}
              page={page}
              color="primary"
              size="small"
              style={{ float: "right" }}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <ViewMoreDialogBox
        openDialogbox={openDialogbox}
        handleClose={handleClose}
        data={userdetails}
      />

      <nav className={showfilter} style={{ top: "0px" }}>
        <div className="filter col-md-12 shadow p-4 ">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="mb-0">Filters</p>
            <div className="dismiss ">
              <span
                id="session_filter_close_btn"
                className="material-symbols-outlined"
                onClick={() => {
                  setshowfilter("sidebar_filter");
                }}
              >
                cancel
              </span>
            </div>
          </div>

          <div className="filter_form">
            <form className=" fillter_form2 " style={{ height: "75vh" }}>
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                  {!isToDateValid() && (
                    <span
                      className="text-danger fw-bold"
                      style={{ fontSize: "10px" }}
                    >
                      To Date cannot be less than From Date*
                    </span>
                  )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Status
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    <option value="Accept">Chat Accepted</option>
                    <option value="chatEnded">Chat Ended</option>
                    <option value="queued">Queued</option>
                    <option value="Abandoned">Abandoned</option>
                    <option value="customerdisconnect">
                      Customer Disconnected
                    </option>
                  </select>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Direction
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setdirection(e.target.value)}
                  >
                    <option value="">Select Direction</option>
                    <option value="Inbound">Inbound</option>
                    <option value="Outbound">Outbound</option>
                    <option value="MC_Outbound">MC_Outbound</option>
                    <option value="Missed Call">Missed Call</option>
                    <option value="CM_Outbound">CM_Outbound</option>
                  </select>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Skillset
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setSkillset(e.target.value)}
                  >
                    <option value="">Select Skillsets</option>
                    {sortedItemsSkillset.length > 0
                      ? sortedItemsSkillset.map((items, index) => {
                          return (
                            <>
                              <option key={index} value={items.skillName}>
                                {items.skillName}
                              </option>
                            </>
                          );
                        })
                      : ""}
                  </select>
                </div>

                {basedOnRole.role == "Supervisor" ? (
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="Select" className="form-label">
                      Agent Name
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      onChange={(e) => setAgentid(e.target.value)}
                    >
                      <option value="">Select Agent Name</option>
                      {agentlist.length > 0 ? (
                        agentlist.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.username}
                            </option>
                          );
                        })
                      ) : (
                        <option>No Agent Found</option>
                      )}
                    </select>
                  </div>
                ) : null}
              </div>
            </form>

            <div className="filter_submit">
              <div className="d-flex">
                <div className="col-md-12 ps-2">
                  <button
                    type="button"
                    id="session_filter_Submit"
                    className="btn btn-primary w-100 text-white"
                    onClick={() => {
                      if (isToDateValid()) {
                        setPage(1);
                        sessionReports();
                        setshowfilter("sidebar_filter");
                      }
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <Dialog
        open={ChatHistoryOpenDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={ChatHistoryCloseDialog}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 5,
            padding: 1,
            maxWidth: "900px",
          },

          backgroundColor: "rgb(0 0 0 / 65%)",
        }}
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600 }}
        >
          CHAT HISTORY
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Stack justifyContent={"center"} alignItems={"center"}>
              <div
                className="chat-box-body"
                style={{
                  backgroundColor: "transparent !important",
                  marginTop: "10px",
                }}
              >
                <div className="chat-logs" style={{ height: "60vh" }}>
                  {ChatHistory &&
                    ChatHistory.map((message) => {
                      if (message.msg_sent_type === "NOTIFICATIONS") {
                        if (message.message === "Customer Ended the Chat") {
                          return (
                            <div
                              className="times"
                              style={{ background: "#d93d32" }}
                            >
                              message.message,
                            </div>
                          );
                        } else {
                          return <div className="times">{message.message}</div>;
                        }
                      } else if (message.senderName == basedOnRole.username) {
                        return (
                          <div className="chat-r">
                            <div className="user-chat-main d-flex justify-content-end flex-column align-items-end">
                              {message.msg_sent_type === "TEXT" ||
                              message.msg_sent_type == "text" ? (
                                <div className="user-chats text-break">
                                  {message.message.includes("http://") ||
                                  message.message.includes("www.") ||
                                  message.message.includes("https://")
                                    ? message.message
                                        .split(" ")
                                        .map((word, index) => {
                                          if (
                                            word.includes("http://") ||
                                            word.includes("https://") ||
                                            word.includes("www.")
                                          ) {
                                            return (
                                              <a
                                                href={word}
                                                key={index}
                                                style={{
                                                  color: "white",
                                                  borderBottom:
                                                    "1px solid grey",
                                                  textDecoration: "underline",
                                                }}
                                                target="_blank"
                                              >
                                                {word}
                                              </a>
                                            );
                                          } else {
                                            return word + " ";
                                          }
                                        })
                                    : message.message}
                                </div>
                              ) : null}

                              {message.msg_sent_type === "APPLICATION" ? (
                                <div className="user-chats-file algin-text">
                                  <a
                                    href={message.message}
                                    target="_blank"
                                    className="text-white"
                                  >
                                    <AiOutlineFileExcel
                                      size={20}
                                      className="excel-icon"
                                    />{" "}
                                    {message.file_name}
                                  </a>
                                </div>
                              ) : null}

                              {message.msg_sent_type === "IMAGE" ? (
                                <div className="card p-2">
                                  <a href={message.message} target="_blank">
                                    <img
                                      src={message.message}
                                      height="130px"
                                      width={150}
                                      alt="image not available"
                                    />
                                  </a>
                                </div>
                              ) : null}

                              {message.msg_sent_type === "VIDEO" ? (
                                <div
                                  className="card p-2"
                                  style={{ borderRadius: "10px 10px 0 10px" }}
                                >
                                  <a href={message.message} target="_blank">
                                    <video width="150" controls>
                                      <source
                                        src={message.message}
                                        type="video/mp4"
                                      />
                                    </video>
                                  </a>
                                </div>
                              ) : null}

                              {message.msg_sent_type === "AUDIO" ? (
                                <div className="user-chats-audio">
                                  <AudioPlayer
                                    src={message.message}
                                    useStyles={useStyles}
                                  />
                                </div>
                              ) : null}
                            </div>
                            <div className="chat-time-r">
                              {moment(message.time).format("h:mm A")} -
                              <div
                                className="mx-1"
                                style={{ fontSize: "10px" }}
                              >
                                {message.senderName}
                              </div>
                            </div>
                          </div>
                        );
                      } else if (message.senderName !== basedOnRole.username) {
                        return (
                          <div className="chat-l">
                            <div className="bot-chat-main d-flex justify-content-start">
                              <div className="d-flex justify-content-start flex-column align-items-start w-100">
                                {message.msg_sent_type === "TEXT" ||
                                message.msg_sent_type === "text" ? (
                                  <div className="bot-chats text-break">
                                    {message.message.includes("http://") ||
                                    message.message.includes("www.") ||
                                    message.message.includes("https://")
                                      ? message.message

                                          .split(" ")
                                          .map((word, index) => {
                                            if (
                                              word.includes("http://") ||
                                              word.includes("https://") ||
                                              word.includes("www.")
                                            ) {
                                              return (
                                                <a
                                                  href={word}
                                                  key={index}
                                                  style={{
                                                    color: "white",
                                                    borderBottom:
                                                      "1px solid #FFFF",
                                                    textDecoration: "underline",
                                                  }}
                                                  target="_blank"
                                                >
                                                  {word}
                                                </a>
                                              );
                                            } else {
                                              return word + " ";
                                            }
                                          })
                                      : message.message}
                                  </div>
                                ) : null}

                                {message.msg_sent_type === "APPLICATION" ? (
                                  <div className="user-chats-file text-break">
                                    <a
                                      href={message.message}
                                      target="_blank"
                                      className="text-white"
                                    >
                                      <AiOutlineFileExcel
                                        size={20}
                                        className="excel-icon"
                                      />{" "}
                                      {message.file_name}
                                    </a>
                                  </div>
                                ) : null}

                                {message.msg_sent_type === "IMAGE" ? (
                                  <div
                                    className="card p-2"
                                    style={{ height: "150px" }}
                                  >
                                    <a href={message.message} target="_blank">
                                      <img
                                        src={message.message}
                                        height="130px"
                                        width={150}
                                        alt="image not available"
                                      />
                                    </a>
                                  </div>
                                ) : null}

                                {message.msg_sent_type === "VIDEO" ? (
                                  <div
                                    className="card p-2"
                                    style={{
                                      borderRadius: "10px 10px 10px 0px",
                                    }}
                                  >
                                    <a href={message.message} target="_blank">
                                      <video width="150" controls>
                                        <source
                                          src={message.message}
                                          type="video/mp4"
                                        />
                                      </video>
                                    </a>
                                  </div>
                                ) : null}

                                {message.msg_sent_type === "AUDIO" ? (
                                  <div className="user-chats-audio">
                                    <AudioPlayer
                                      src={message.message}
                                      useStyles={useStyles}
                                    />
                                  </div>
                                ) : null}
                              </div>
                            </div>

                            <div className="chat-time-l">
                              {moment(message.time).format("h:mm A")} -
                              <div
                                className="mx-1"
                                style={{ fontSize: "10px" }}
                              >
                                {message.senderName}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </Stack>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Sessionreport;
